import { MenuItem, ListItemIcon, ListItemText } from "@mui/material";

const CustomMenuItem = ({ icon: IconComponent, text, color, item, row}) => {

    const handleMenuItemClick = (item, row) => {
        console.log("row", row)
        if (item.handler) {
            item.handler(row); // Call the function associated with the menu item
        }
    };

    
    return (
        <MenuItem  onClick={() => handleMenuItemClick(item, row)}>
            <ListItemIcon>
                <IconComponent  style={{ color }} fontSize="small" />
            </ListItemIcon>
            <ListItemText style={{ color }}>{text}</ListItemText>
        </MenuItem>
    );
};

export default CustomMenuItem;
